import { ITimecard } from '../interface/ISelectedDate'
import { store } from './Store'
import { setSelectedDate } from './slice/SelectedDateSlice'
import { setLoadingDate } from './slice/LoadingDateSlice'
import { injectedEndpoints } from '@/api/InjectedEndpoints'

export const UpdateStoreHelper = async (date: string, forceRefetch: boolean) => {
    store.dispatch(setLoadingDate(true))

    try {
        const timecard: ITimecard = await store.dispatch(injectedEndpoints.endpoints.getTimecard.initiate(date, { forceRefetch: forceRefetch, subscribe: false })).unwrap()
        store.dispatch(setSelectedDate(timecard))
    } catch (error) {
        console.log(error)
    } finally {
        store.dispatch(setLoadingDate(false))
    }
}
